import React from 'react';

const Word = ({
  selectedWord = '',
  correctLetters = [],
  onLetterClick = () => {},
  disabledLetters = []
}) => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

  return (
    <>
      <div className="hangman-word">
        {selectedWord.split('').map((letter, i) => (
          <span 
            className="hangman-letter" 
            key={i} 
            style={{ 
              textTransform: 'uppercase',
              color: correctLetters.includes(letter) ? '#fff' : 'transparent',
              borderBottom: '3px solid #2980b9'
            }}
          >
            {correctLetters.includes(letter) ? letter.toUpperCase() : ''}
          </span>
        ))}
      </div>
    </>
  );
};

export default Word;
